module.exports = __webpack_public_path__ + "img/2.e57dff58.png";